<template>
  <div v-if="game" class="col-md-11 col-xl-9" style="margin:auto;margin-top:20px">
    <!-- head -->
      <div class="inline">
        <img width="64" height="64" :src="backendUrl+'/'+game.iconUrl"/>
      </div>
      <div class="inline">
        <h1>{{ game.name }}</h1>
      </div>
    <!-- images -->
    <b-carousel class="carousel"
                controls
                background="#FFF"
                img-width="100px"
                img-height="100px"
                :interval="8000">
      <div class="carousel-item" v-for="image in game.imagesUrl" :key="image">
        <img :src="backendUrl+'/'+image"/>
      </div>
    </b-carousel>

    <b-tabs card class="tabs">
      <!-- description -->
      <b-tab title="Description" active>
        <div v-html="game.description"></div>
      </b-tab>
      <!-- liens regles -->
      <b-tab title="Règles" v-if="game.youtube_rules_url || game.text_rules_url">
        <div class="centered">
          <iframe class="video" v-if="game.youtube_rules_url" width="560" height="315" :src="'https://www.youtube.com/embed/'+game.youtube_rules_url" frameborder="0" allow="encrypted-media" allowfullscreen></iframe>
        </div>
        <div v-html="game.rules"></div>
        <div class="centered">
          <b-button target="_blank" v-if="game.text_rules_url" :href="game.text_rules_url">
              Texte des règles
          </b-button>
        </div>
      </b-tab>
      <!-- avis -->
      <b-tab title="Avis" v-if="game.view">
        <div v-html="game.view"></div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'GameDetail',
  components: {
  },
  data: function(){
    return {
      game: null,
      backendUrl: Vue.$backend.getBackendUrl(),
    }
  },
  created: function(){
    Vue.$backend.getGameDetails(this.$route.params.name).then(res => this.game = res[0])
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.centered {
  text-align: center;
}

.carousel-item {
  outline: none;
  text-align: center;
}
.carousel-item img{
  height: 300px;
  width: auto;
}

.inline{
  display:inline-block;
  vertical-align: middle;
}

.video{
  width: 100%;
  max-width: 500px;
}

h1 {
  margin-left: 20px;
}

.card-header{
  background-color: white;
}

</style>
